import React from 'react';
import moment from 'moment';
import {
  useGetMovieCreditsQuery,
  useGetTvCreditsQuery,
} from '../../services/movieApi';
import { Link } from 'react-router-dom';

const HeroItem = ({ items, movieId, tvId }) => {
  const getPosterURL = (posterpath) => {
    return `https://image.tmdb.org/t/p/original/${posterpath}`;
  };
  const getPosterCard = (posterpath) => {
    return `https://image.tmdb.org/t/p/w500/${posterpath}`;
  };
  const imgPath = items?.backdrop_path;
  const posterPath = items?.poster_path;
  const minutes = moment
    .duration(items?.runtime || items?.last_episode_to_air.runtime, 'minutes')
    .minutes();
  const hours = moment
    .duration(items?.runtime || items?.last_episode_to_air.runtime, 'minutes')
    .hours();

  const { data: castsMovie } = useGetMovieCreditsQuery({ movieId });
  const { data: castsTv } = useGetTvCreditsQuery({
    tvId,
  });
  console.log(items);
  const sortedCasts =
    castsMovie?.cast.length || castsTv?.cast.length > 6
      ? castsMovie?.cast.slice(0, 6) || castsTv?.cast.slice(0, 6)
      : castsMovie?.cast || castsTv?.cast;
  return (
    <div className="w-full h-full bg-black relative">
      <div
        style={{
          backgroundImage: `url(${getPosterURL(imgPath)})`,
        }}
        className={
          'relative bg-cover bg-no-repeat bg-center h-[50vh] before:absolute before:top-0 before:left-0 before:w-full before:h-full before:bg-black/60 after:absolute after:bottom-0 after:left-0 after:w-full after:h-24 after:bg-gradient-to-t after:from-black after:to-black/5'
        }
      />
      <div className="flex w-full -m-72 mb-auto px-6 mx-auto pb-8 relative text-white md:-m-64 md:mb-auto md:container md:mx-auto md:px-6 md:pb-10 md:items-center md:gap-4">
        <img
          src={getPosterCard(posterPath)}
          className="rounded-3xl shadow-xl max-w-full  md:w-[300px] lg:w-[400px] 2xl:w-[500px] relative max-md:hidden"
        />
        <div className="flex flex-col gap-3 md:gap-4">
          <h1 className="font-bold text-2xl md:text-5xl">
            {items?.title || items?.original_name}
          </h1>
          <div className="flex flex-row text-white gap-2 items-center text-xs md:text-sm">
            <p>{items?.release_date || items?.last_air_date}</p>
            <span>-</span>
            <p>
              {hours}h{minutes}m
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {items?.genres.map((item) => (
              <p
                key={item.name}
                className="border-2 border-solid rounded-2xl cursor-pointer duration-300 py-1 px-2 text-sm md:scale-95 md:hover:scale-100 md:px-4 md:py-1"
              >
                {item.name}
              </p>
            ))}
          </div>
          <h2 className=" italic text-white/60 md:text-xl ">
            {items?.tagline}
          </h2>
          <h3 className=" text-sm">{items?.overview}</h3>
          <div className="flex flex-row w-full justify-between">
            <h4 className=" font-bold text-lg md:text-2xl">Casts</h4>
            <Link
              to={`/movie/${movieId}/cast`}
              className="border px-3 rounded-lg text-sm scale-95 duration-300 hover:scale-100"
            >
              View More
            </Link>
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {sortedCasts?.map((value) => (
              <div
                key={value.name}
                className="flex flex-col w-28 md:w-32 items-center bg-white/25 rounded-md overflow-auto scale-95 duration-300 cursor-pointer hover:scale-100 "
              >
                <img
                  src={getPosterCard(value?.profile_path)}
                  className="rounded-t-md md:w-full"
                />
                <div className="text-xs px-1 py-1 my-auto md:py-2 md:px-1 w-full">
                  <p className="font-bold ">{value.name}</p>
                  <p>{value.character}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroItem;
